import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFoodBell: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFoodBell"><Path d="M12.75 4H11.25V5.08952C9.01541 5.25075 6.81938 6.13417 5.12265 7.75447C3.22661 9.5651 2 12.252 2 15.75V16.5H22V15.75C22 12.252 20.7734 9.5651 18.8773 7.75447C17.1806 6.13417 14.9846 5.25075 12.75 5.08952V4Z" fill="currentColor"/><Path d="M2 17.5V19H9V20H15V19H22V17.5H2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFoodBell;
